import config from '../config';
import {
  authHeader,
  customFetch,
  commonRequestOptions,
  handleResponse,
  jsonHeader,
} from '../helpers';

const endpointPath = config.api.API_URL + '/custom_property_list_value';

export const customPropertyListValueService = {
  create,
  destroy,
  getByCustomPropertyId,
  update,
  checkDestroy,
};

async function checkDestroy(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}/check_delete`, requestOptions, signal).then(handleResponse);
}

async function update(items, signal) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };
  return customFetch(endpointPath, requestOptions, signal).then(handleResponse);
}

async function destroy(items, signal) {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}

async function create(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(endpointPath, requestOptions, signal).then(handleResponse);
}

async function getByCustomPropertyId(id, signal) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    ...commonRequestOptions(),
  };

  return customFetch(`${endpointPath}/custom_property/${id}`, requestOptions, signal).then(
    handleResponse
  );
}
